export function formatMoney(value: number | null | undefined) {
  if (value == null) return '-';
  const sign = value >= 0 ? '' : '-';
  return `${sign}$${Math.abs(value)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
}
